// extracted by mini-css-extract-plugin
export default {"confirmation":"Confirmation_confirmation__gLPMt"};